const isMatchingMessage = (chatMessageEl, storedData, compareText = false) => {
  if (!storedData.getHtml()) return false;
  if (compareText) {
    return !storedData.getControl()?.text
      || storedData.getControl().text
      === chatMessageEl.querySelector('.uiOutputRichText')?.textContent;
  }
  return !storedData.getControl()?.renderedBy
    || storedData.getControl().renderedBy
    === chatMessageEl.dataset.auraRenderedBy;
};

const isMatchingMessageUpToDate = (
  chatMessageEl,
  storedData,
  compareText,
) => {
  if (!isMatchingMessage(chatMessageEl, storedData, compareText)) return true;
  const currentText = chatMessageEl.querySelector('.uiOutputRichText')?.textContent;
  const controlText = storedData.getControl()?.text;

  // true if it was already updated and the content differs from the markdown
  return controlText && currentText !== controlText;
};

const render = (chatMessageEl, storedData, compareText) => {
  if (isMatchingMessageUpToDate(chatMessageEl, storedData, compareText)) {
    return;
  }

  const richTextEl = chatMessageEl.querySelector('.uiOutputRichText');
  if (!richTextEl) return;

  storedData.setControl({
    text: `${richTextEl.textContent}`,
    renderedBy: chatMessageEl.dataset.auraRenderedBy,
  });
  richTextEl.innerHTML = storedData.getHtml();
};

const listenToNewMessages = (window, sidebarBody, { getStoredData }) => {
  new window.MutationObserver((mutationsList) => (
    mutationsList
      .filter((mutation) => mutation.type === 'childList')
      .forEach((mutation) => mutation.addedNodes
        .forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          const { classList } = node;
          if (classList.contains('agent') && classList.contains('chatMessage')) {
            const storedData = getStoredData();
            render(node, storedData);
          } else if (classList.contains('embeddedServiceLiveAgentSidebarFeature')) {
            const storedData = getStoredData();
            node.querySelectorAll('.agent.chatMessage').forEach(
              (messageNode) => render(messageNode, storedData),
            );
          }
        }))
  )).observe(sidebarBody, { childList: true, subtree: true });
};

const init = (window, { getStoredData }) => {
  const sidebarBody = window.document.querySelector(
    '.embeddedServiceSidebar .activeFeature',
  );
  sidebarBody.querySelectorAll('.messageWrapper .agent.chatMessage')
    .forEach((chatMessage) => render(chatMessage, getStoredData(), true));

  listenToNewMessages(window, sidebarBody, { getStoredData });
};

export default { init };
